"use client";

import { useWebchatStore } from "../store";
import { UnreadMessageBadge } from "./UnreadMessageBadge";
import { cn } from "@deputy-ai/common";
import { IoChevronDown } from "react-icons/io5";
import { RiChat1Fill } from "react-icons/ri";

export function ToggleBottom() {
  const {
    use: { visible },
    bind: { setVisible },
  } = useWebchatStore();

  return (
    <div
      className={cn(
        "rounded-full bg-black p-3 text-3xl text-white shadow-gray-800",
        "absolute right-4 bottom-4 scale-95 cursor-pointer",
        "transition-all hover:scale-100 active:scale-90",
        visible && "xsm:block hidden"
      )}
      onClick={() => setVisible(!visible)}
    >
      <IoChevronDown
        className={cn(
          visible ? "rotate-0 opacity-100" : "rotate-45 opacity-0",
          "absolute transition-all duration-300"
        )}
      />
      <RiChat1Fill
        className={cn(
          visible ? "-rotate-45 opacity-0" : "rotate-0 opacity-100",
          "transition-all duration-300"
        )}
      />
      {!visible && <UnreadMessageBadge className="absolute -top-2 -right-2" />}
    </div>
  );
}
